import React, {Fragment, useState, useEffect} from "react";

import DrawerToggleButton from "../SideDrawer/DrawerToggleButton";
import "./Toolbar.css";
import "../Notification/notification.css";
import {Link} from "react-router-dom";
import {connect} from "react-redux";
import {actionIsNotificationRead, logout} from "../../../../actions/auth";
import userLogo from "../../../../assets/img/nophoto.png";
import NavLogo from "../../../../assets/img/logo-transparent.png";
import NavLogo1 from "../../../../assets/img/prime.png";
import NotificationItem from "../Notification/NotificationItem";
import DataNotFound from "../../DataNotFound";
import PropTypes from 'prop-types';
import classnames from "classnames";
import {ADD_PROPERTIES, AGENTS, CHAT, HOME, PROPERTIES, ADMIN, PAGE_TITLE} from "../../../../actions/types";
import swal from "sweetalert";
import $ from 'jquery'


const Toolbar = ({auth: {isAuthenticated, user}, logout, actionIsNotificationRead, drawerClickHandler, isToggle, scenario}) => {
    /*console.log(window.location.pathname ,"location")
    console.log(window.location.pathname ==='/dashboard')*/

    const [logo, setLog] = useState(false)
    useEffect(() => {
        window.addEventListener('scroll', () => {
            var mainMenuTop = $(".toolbar");
            let scrollTop = document.documentElement.scrollTop;

            if (scrollTop >= 100) {
                setLog(true);
            } else {
                setLog(false);
            }
        });
    });
    const NotificationRead = () => {
        console.log('API called from R')
        actionIsNotificationRead(user._id)
    };
    const authLinks = (
        <ul>
            {/*<li>*/}
            {/*<span className="text-white">{user.name}</span>*/}
            {/*</li>*/}
            <li className={classnames({'active': scenario === HOME})}>
                <Link to="/home">Home</Link>
            </li>
            {/*{*/}
            {/*((user && user.role) && (user.role.name === "Super Admin" || user.role.name === "Admin")) &&*/}
            {/*<li className={classnames({'active': scenario === ADMIN})}>*/}
            {/*<Link to={`/users`}>*/}
            {/*<span className="hide-sm">Users</span>*/}
            {/*</Link>*/}
            {/*</li>*/}
            {/*}*/}
            {/*{
                ((user && user.role) && (user.role.name === "Super Admin")) &&
                <li className={classnames({'active': scenario === PAGE_TITLE})}>
                    <Link to={`/page-title`}>
                        <span className="hide-sm">Page-Title</span>
                    </Link>
                </li>
            }*/}
            <li className={classnames({'active': scenario === AGENTS})}>
                <Link to="/agent-listing">Agents</Link>
            </li>
            <li className={classnames({'active': scenario === PROPERTIES})}>
                <Link to="/properties">Properties</Link>
            </li>
            <li className={classnames({'active': scenario === CHAT})}>
                <Link to="/private-chat">Chat</Link>
            </li>
            {
                (user && user.role.name !== 'User')
                    ?
                    <li className={classnames({'active': scenario === ADD_PROPERTIES})}>
                        <Link to="/add-property">Add Property</Link>
                    </li>
                    :
                    <li className={classnames({'active': scenario === ADD_PROPERTIES})}>
                        <Link to='' className="cursor-pointer" onClick={() =>
                            swal({
                                title: "you don't have permission to Add Property?",
                                //text: "Are you sure want to Delete this Group ?",
                                icon: "warning",
                                buttons: [false, "Ok"],
                                dangerMode: true,
                            })}>Add Property</Link>
                    </li>
            }

            <li className={"notification-section"}>

                <div className="dropdown profile-drop">
                    <Link to={''} className="dropdown-toggle"
                          type="button" id="dropdownMenuButton"
                          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i className="fa fa-bell fa-lg "/>
                        {((user && user.notification && user.notification.length > 0) && user.notification.filter(n => n.is_read === false).length > 0) &&
                        <span
                            className="unread-notification"
                            onMouseLeave={NotificationRead}>{user.notification.filter(n => n.is_read === false).length}</span>}
                    </Link>
                    <div className="dropdown-menu profile-menu" aria-labelledby="dropdownMenuButton">
                        <div className="header text-center h6">
                            Notification
                        </div>


                        {(user && user.notification && user.notification.length > 0) ? user.notification.map((data, index) =>
                                <NotificationItem
                                    key={index}
                                    title={data.notification ? data.notification.title : ''}
                                    userProfile={data.user_avatar ? data.user_avatar : userLogo}
                                    notificationId={data._id}
                                    user_name={data.user_name}
                                    user_avtart={data.user_avatar}
                                    time={data.notification ? data.notification.createdAt : ''}
                                    action={data.notification ? data.notification.action : ''}
                                    name={data.notification && data.notification.title ? data.notification.title : ''}
                                    user_id={data.notification && data.notification.user ? data.notification.user : 0}
                                />) :
                            <div className="dropdown-item">
                                <DataNotFound message={"Not Found"}/>
                            </div>}

                    </div>
                </div>
            </li>
            <li className="dropdown">
                <img src={user && user.avatar ? user.avatar : userLogo} alt="Avtar"
                     className={'dropdown-toggle nav-user-log'} id="dropdownMenuButton"
                     data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"/>
                <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <Link className="dropdown-item"
                          to="/user-profile">{user.name && user.name.charAt(0).toUpperCase() + user.name.slice(1)}</Link>
                    <Link className="dropdown-item" to="/invite">Invite</Link>
                    {/*{((user && user.role) && (user.role.name === "Super Admin")) &&*/}
                    {/*<Link className="dropdown-item" to="/permission">Permission</Link>}*/}
                    {
                        user && user.role.name !== "User" ?
                            <Link className="dropdown-item" to="/private-properties">My Properties</Link>:
                            ''
                    }
                    <Link className="dropdown-item" to="/connections">My Connection</Link>
                    <Link className="dropdown-item" to="/change-password">Change Password</Link>

                    <Link to={'/login'} onClick={() => {
                        localStorage.removeItem('vip_token');
                        // window.location.href='/login';
                        logout()
                    }} className="dropdown-item">Logout</Link>
                </div>


            </li>
        </ul>
    );

    const guestLinks = (
        <ul>
            <li>
                <Link to="/login">Sign In</Link>
            </li>
        </ul>
    );


    return (
        <header className={`toolbar`}>
            <nav className="toolbar__navigation  ">
                <div className="toolbar__toggle-button">

                    <DrawerToggleButton click={drawerClickHandler} isToggle={isToggle}/>
                </div>
                <div className="toolbar__logo">
                    {
                        localStorage.getItem('vip_token') ?
                            <Fragment>
                                <Link to="/" id="Logo">
                                    <img src={!logo ? NavLogo : NavLogo1} alt="NavLogo" className="main-logo"/>
                                </Link>
                            </Fragment>
                            :
                            <Link to="/login">
                                <img src={!logo ? NavLogo : NavLogo1} alt="NavLogo"/>
                                {/*<img src={NavLogo} alt="NavLogo" style={{width:'100px'}}/>*/}
                            </Link>
                    }
                </div>
                <div className="spacer"/>
                <div className="toolbar_navigation-items">
                    <Fragment>{isAuthenticated ? authLinks : guestLinks}</Fragment>
                </div>
            </nav>
        </header>
    );

};


Toolbar.propTypes = {
    logout: PropTypes.func.isRequired,
    drawerClickHandler: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
    auth: state.auth
});

export default connect(mapStateToProps, {logout, actionIsNotificationRead})(Toolbar);



